import styled from "styled-components";

export const StyledFaqContainer = styled.div`
  background-color: #ffffff;
`;

export const StyledFaqHeading = styled.div`
    color: #000;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 8px;
`;

export const StyledFaqItem = styled.div`
  border-bottom: 1px solid #e5e5e5;
  &:last-child {
    border-bottom: none;
  }
`;

export const StyledQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    opacity: 0.8;
  }
  
  span {
    color: #0A0A0A;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
`;

export const StyledAnswer = styled.div`
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  animation: fadeIn 0.3s ease-in-out;
  margin-bottom: 16px;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const StyledChevronIcon = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  transform: ${props => props.$isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  
  svg {
    width: 24px;
    height: 24px;
  }
`;
